module.exports = __webpack_public_path__ + "media/images/vector-score-a84fd30a.png";